import { AFFILIATE_SETTINGS_API } from 'modules/profile/affiliate-settings/api/affiliate-settings-api'
import { AffiliateSettingsInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useAffiliateSettings() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateSettingsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: userAffiliateSettings, mutate: mutateAffiliateSettings } = useSWR(() => {
    if (user) {
      return AFFILIATE_SETTINGS_API
    }
    return null
  }, fetcher)
  return { userAffiliateSettings, mutateAffiliateSettings }
}
